// UI strings for a borrowing's own stress or Peterson's alternate pronunciation, shown beside the
// regular stress (StressWord; engine rules/borrowed-stress.ts: buz·DA·ri), or the regular stress
// beside Peterson's pronunciation when that is the main one (daor: da·OR, "myös daor (yksitavuinen,
// kirjoitusasun mukaan)"). Finnish first; en has the same shape.
import { defineArea } from '../area';

export const borrowedStressFi = {
  /** before the borrowed stress display */
  also: 'myös',
  /** after it, in brackets */
  why: 'lainasana, Peterson',
  /** after Peterson's alternate pronunciation (da·OR), in brackets */
  whyAlternate: 'Peterson',
  /** after the regular stress shown beside the main one (daor), in brackets */
  whyRegular: 'kirjoitusasun mukaan',
  /** before whyRegular when the regular reading is one syllable */
  oneSyllable: 'yksitavuinen',
};

export const borrowedStressEn: typeof borrowedStressFi = {
  also: 'also',
  why: 'borrowing, Peterson',
  whyAlternate: 'Peterson',
  whyRegular: 'by the spelling',
  oneSyllable: 'one syllable',
};

// Messages.borrowedStress (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('borrowedStress', borrowedStressFi, borrowedStressEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof borrowedStressFi> {}
}
